import { Stripe } from 'Jsx/CheckoutV4/types/StripeV2';

export const publishStripePublicKey = (stripeLib: Stripe) => {
  const stripePublicKey = window.PINAX_STRIPE_PUBLIC_KEY;

  if (stripePublicKey) {
    stripeLib.setPublishableKey(stripePublicKey);
  } else {
    throw new Error(`You need to add a stripe public key`);
  }
};

export const publishStripeMXPublicKey = (stripeLib: Stripe) => {
  const stripeMexicoPublicKey = window.PINAX_STRIPE_MEXICAN_PUBLIC_KEY;

  if (stripeMexicoPublicKey) {
    stripeLib.setPublishableKey(stripeMexicoPublicKey);
  } else {
    throw new Error(`You need to add a stripe public key`);
  }
};
